export default __webpack_public_path__ + "static/media/philosophies_of_ballad.a841f958.png";